// A small, warm set of lines. Plain, human, never preachy. Used for the
// daily line on the dashboard and the gentler lines on the journal care
// rail. Two pools: everyday lift, and softer lines for a hard stretch.

export const DAILY_QUOTES = [
  "Small and steady beats big and rare.",
  "You do not have to see the whole staircase, just the next step.",
  "Progress is quiet. Show up anyway.",
  "The work you do today is a gift to the you of next month.",
  "One honest sentence is enough to start.",
  "Direction matters more than speed.",
  "You are allowed to change your mind and still be on track.",
  "Done is a kind of brave.",
  "The bend is not the end of the road, just a turn in it.",
  "Curiosity is a skill. You are practising it right now.",
  "A slow start is still a start.",
  "You have gotten through every hard day so far. That is a record worth trusting.",
  "Effort you cannot see yet is still effort.",
  "Comparison is a thief. Run your own race today.",
  "The point is not to be sure. The point is to keep looking.",
  "Rest is part of the plan, not a break from it.",
  "You can do hard things in small pieces.",
  "What you pay attention to grows. Aim it kindly.",
  "Momentum loves a tiny first move.",
  "Be patient with the parts of you that are still becoming.",
  "The goal is not perfect. The goal is honest and moving.",
  "Every check in is you keeping a promise to yourself.",
  "You are closer than the middle feels.",
  "Confidence is built, not found. You are building it.",
];

export const GENTLE_QUOTES = [
  "Rough days are data, not a verdict. You are still on your path.",
  "You do not have to fix everything today. One small thing is plenty.",
  "Hard stretches pass. Be as kind to yourself as you would to a friend.",
  "Feeling low does not undo your progress. It is just weather.",
  "You are allowed to ask for help. That is strength, not a tell.",
  "Slow is fine. Stopped for a rest is fine. You are still going.",
  "This is a lot right now. You do not have to carry it all at once.",
  "The fact that you showed up here, on a hard day, counts.",
];

function dayIndex() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  return Math.floor(diff / 86400000);
}

// Stable within a day, fresh the next.
export function quoteOfDay() {
  return DAILY_QUOTES[dayIndex() % DAILY_QUOTES.length];
}

export function gentleQuoteOfDay() {
  return GENTLE_QUOTES[dayIndex() % GENTLE_QUOTES.length];
}

// Moods that call for the softer pool, whatever the archetype.
const LOW_MOODS = new Set(["low", "rough", "drained", "stressed", "sad", "anxious", "tired", "cooked", "shambles", "melting", "salty"]);

/**
 * KLA-041: the daily line, chosen by who they are and how they said
 * they feel. A hard day gets the gentle pool; otherwise the line leans
 * into their archetype family; no archetype falls back to the shared
 * pool. Deterministic within a day.
 */
export function personalQuoteOfDay({ arch, mood, familyQuotes } = {}) {
  const m = (mood || "").toLowerCase();
  if (m && LOW_MOODS.has(m)) {
    return { line: gentleQuoteOfDay(), tuned: "for a softer day" };
  }
  const pool = familyQuotes && familyQuotes.length ? familyQuotes : null;
  if (pool) {
    const bare = (arch?.name || "").replace(/^the\s+/i, "").toLowerCase();
    return {
      line: pool[dayIndex() % pool.length],
      tuned: bare ? `for the ${bare} in you` : "",
    };
  }
  return { line: quoteOfDay(), tuned: "" };
}
